import React from 'react';

import { ISVGPersonalProps } from 'types/svg';

export const remove: ISVGPersonalProps = {
  viewBox: '0 0 28 28',
  fill: 'currentColor',
  content: (
    <g id="remove_icon" data-name="remove icon" transform="translate(18459.691 2947.492)">
      <rect
        id="Rectangle_2788"
        data-name="Rectangle 2788"
        width="28"
        height="28"
        transform="translate(-18459.691 -2947.492)"
        fill="none"
      />
      <g id="Group_4104" data-name="Group 4104" transform="translate(-18454.926 -2942.727)">
        <g id="Group_4103" data-name="Group 4103">
          <path
            id="Path_7148"
            data-name="Path 7148"
            d="M9.245,0A9.245,9.245,0,1,0,18.49,9.244,9.245,9.245,0,0,0,9.245,0m0,16.809a7.564,7.564,0,1,1,7.564-7.564,7.564,7.564,0,0,1-7.564,7.564"
            transform="translate(0 0.001)"
            fill="currentColor"
          />
          <path
            id="Path_7149"
            data-name="Path 7149"
            d="M135.564,213.333H128.84a.84.84,0,0,0,0,1.681h6.724a.84.84,0,0,0,0-1.681"
            transform="translate(-122.957 -204.928)"
            fill="currentColor"
          />
        </g>
      </g>
    </g>
  ),
};
